import { defineMessages } from "react-intl";

const messages = defineMessages({
  clustersWarning: {
    id: "map.tool.lasso.bulk.clustersWarning",
    defaultMessage:
      "Please note, <b>pins inside of clusters may or may not be selected</b>. Please zoom in to view which pins within the cluster are inside the Lasso shape.",
    description: "Lasso mode bulk - cluster warning",
  },
  drawAgain: {
    id: "map.tool.lasso.bulk.drawAgain",
    defaultMessage: "Draw Again",
    description: "Lasso mode bulk Draw Again button title",
  },
  largeSelection: {
    id: "map.tool.lasso.bulk.largeSelection",
    defaultMessage: "Please select fewer than 1000 pins to perform actions via Lasso.",
    description: "Lasso mode bulk notification about large selection",
  },

  noAccessToDeleteWarning: {
    id: "map.tool.lasso.bulk.noAccessToDeleteWarning",
    defaultMessage:
      "<b>You do not have access to delete any of the selected records.</b> You can still add records to routes or groups you have access to. To make bulk edits,  lasso another selection or contact your admin to grant you access.",
    description: "Lasso mode bulk - no access to delete warning",
  },
  noAccessToEditWarning: {
    id: "map.tool.lasso.bulk.noAccessToEditWarning",
    defaultMessage:
      "<b>You do not have access to edit any of the selected records.</b> You can still add records to routes or groups you have access to. To make bulk edits,  lasso another selection or contact your admin to grant you access.",
    description: "Lasso mode bulk - no access to edit warning",
  },
  severalEntityTypesWarning: {
    id: "map.tool.lasso.bulk.severalEntityTypes.warning",
    defaultMessage:
      "Bulk edit is disabled when multiple record types are selected with the lassoing tool. Please select only one record type at a time to enable this feature.",
    description: "Lasso mode bulk notification about multiply types selected",
  },
});

export default messages;
